import Vue from 'vue';
import  LineChart  from './charts/LineChart.js';
import  PieChart  from './charts/PieChart.js';
import  BarChart  from './charts/BarChart.js';

Vue.component('line-chart', LineChart);
Vue.component('pie-chart', PieChart);
Vue.component('bar-chart', BarChart);
